import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ConfigService } from '../config.service';
import { IConfigAddPayload, IConfigForm } from '../config.interface';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';

@Component({
    selector: 'app-add-config',
    templateUrl: './add-config.component.html',
    styleUrls: ['./add-config.component.scss'],
})
export class AddConfigComponent {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;
    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        value: new FormControl('', [Validators.required]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddConfigComponent>,
        private configService: ConfigService,
        private notificationService: NotificationService,
        private authService: AuthService
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, value } = this.form.value as IConfigForm;
        const slug = name
            .split(' ')
            .map((item) => item.toLowerCase())
            .join('_');
        const newConfig: IConfigAddPayload = {
            name,
            value,
        };

        this.configService
            .addConfig(newConfig)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
